import styled from '@themes/theme'

export const MatchRecordWrap = styled.div`
  padding-top: 10px;
  background: ${props => props.theme.color.themeTxt};
  .team-info-item {
    &.center {
      flex-flow: row;
      justify-content: space-between;
      margin-bottom: 20px;
    }
    .team {
      color: ${props => props.theme.color.modalTxt};
    }
    .score {
      font-size: ${props => props.theme.font.xxlarge};
      color: ${props => props.theme.color.modalTxt};
    }
    .match-tag {
      position: absolute;
      bottom: -15px;
      left: 50%;
      transform: translateX(-50%);
      padding: 2px 8px;
      background: ${props => props.theme.color.modalBg};
      color: ${props => props.theme.color.modalgray};
      font-weight: ${props => props.theme.fontW.medium};
      height: 20px;
      width: auto;
      line-height: 1.6rem;
      border-radius: 4px;
      white-space: nowrap;
    }
  }

  .timeline {
    &, * {
      color: ${props => props.theme.color.modalTxt};
    }
    &--table {
      .table {
        width: 100% !important;
      }
    }
  }
  .timeline:nth-of-type(3) {
    background: ${props => props.theme.color.modalBg};
    text-align: left;
    height: 220px;
    &.timeline-none {
      height: 12px;
      background-color: ${props => props.theme.color.themeTxt};
    }
  }
`
